export * from '@primeuix/themes/material/organizationchart';
export { default } from '@primeuix/themes/material/organizationchart';
